const cleanFileNameSpaces = function handleCleanFileNameSpaces(
  fileName: string
): string {
  return fileName.replace(/ /g, '+');
};

const cleanFileNameInvalidPathCharacters = function handleCleanFileNameInvalidPathCharacters(
  fileName: string
): string {
  return fileName.replace(
    // eslint-disable-next-line no-control-regex
    /[\x22,\x3C,\x3E,\x7C,\x00,\x01,\x02,\x03,\x04,\x05,\x06,\x07,\x08,\x09,\x0A,\x0B,\x0C,\x0D,\x0E,\x0F,\x10,\x11,\x12,\x13,\x14,\x15,\x16,\x17,\x18,\x19,\x1A,\x1B,\x1C,\x1D,\x1E,\x1F,\x3A,\x2A,\x3F,\x5C,\x2F,\x23,\x2B,\x5B,\x5D,\x28,\x29,\x27]/g,
    '_'
  );
};

const clean = function cleanFileName(fileName: string): string {
  return cleanFileNameSpaces(cleanFileNameInvalidPathCharacters(fileName));
};

export default clean;
